export var settle = function settle(val, target, range) {
  var lowerRange = val > target - range && val < target;
  var upperRange = val < target + range && val > target;
  return lowerRange || upperRange ? target : val;
};
export var getPointFromTouch = function getPointFromTouch(touch) {
  return {
    x: touch.clientX,
    y: touch.clientY
  };
};
export var getDistanceBetweenPoints = function getDistanceBetweenPoints(pointA, pointB) {
  return Math.sqrt(Math.pow(pointA.y - pointB.y, 2) + Math.pow(pointA.x - pointB.x, 2));
};
export var between = function between(min, max, value) {
  return Math.min(max, Math.max(min, value));
};


//////////////////
// WEBPACK FOOTER
// ./~/react-image-video-lightbox/es/utils.js
// module id = 2427
// module chunks = 0